import React from 'react'
import { useSelector } from 'react-redux'
import { Container } from '../../../components'

const MainContent = () => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)

  return (
    <Container>
      <div className="pt-8 lg:pt-20 pb-16 lg:pb-24">
        <div className="flex flex-wrap mb-6 lg:mb-12 -mx-4">
          <div className="md:w-4/12 lg:w-3/12 px-4">
            <h2 className="uppercase text-lg lg:text-2xl font-bold mb-2">
              {translation.TNC.terms_of_use[language.name]}
            </h2>
          </div>
          <div className="md:w-8/12 lg:w-9/12 px-4 text-gray-444 text-sm entry-content">
            <p>{translation.TNC.terms_of_use_content[language.name]}</p>
          </div>
        </div>

        <div className="flex flex-wrap mb-6 lg:mb-12 -mx-4">
          <div className="md:w-4/12 lg:w-3/12 px-4">
            <h2 className="uppercase text-lg lg:text-2xl font-bold mb-2">
              {translation.TNC.your_responsibilities[language.name]}
            </h2>
          </div>
          <div className="md:w-8/12 lg:w-9/12 px-4 text-gray-444 text-sm entry-content" dangerouslySetInnerHTML={{__html: translation.TNC.your_responsibilities_content[language.name]}}></div>
        </div>

        <div className="flex flex-wrap mb-6 lg:mb-12 -mx-4">
          <div className="md:w-4/12 lg:w-3/12 px-4">
            <h2 className="uppercase text-lg lg:text-2xl font-bold mb-2">
              {translation.TNC.privacy[language.name]}
            </h2>
          </div>
          <div className="md:w-8/12 lg:w-9/12 px-4 text-gray-444 text-sm entry-content">
            <p>{translation.TNC.privacy_content[language.name]}</p>
          </div>
        </div>

        <div className="flex flex-wrap -mx-4">
          <div className="md:w-4/12 lg:w-3/12 px-4">
            <h2 className="uppercase text-lg lg:text-2xl font-bold mb-2">
              {translation.TNC.data_security_and_monitoring[language.name]}
            </h2>
          </div>
          <div className="md:w-8/12 lg:w-9/12 px-4 text-gray-444 text-sm entry-content">
            <p>{translation.TNC.data_security_and_monitoring_content[language.name]}</p>
          </div>
        </div>
      </div>
    </Container>
  )
}

export { MainContent }
